import React, { useEffect, useState } from "react";
import { OrderStatuses } from "../../../config";
import { ORDER_IN_PROGRESS_MESSAGE, ORDER_IN_QUEUE_MESSAGE } from "../../../config/messages";
import { PrimaryTextLight } from "../../../components/Texts";
import styled from "styled-components";

const Wrapper = styled.div`
	width: 100%;
	text-align: left;
	padding:0 1rem 1rem 1rem;
`;

const ActiveOrderMessage = ({ orderData }: any) => {
	const [activeOrderMessage, setActiveOrderMessage] = useState<string>("");

	useEffect(() => {
		if (orderData?.status === OrderStatuses.IN_QUEUE) {
			setActiveOrderMessage(ORDER_IN_QUEUE_MESSAGE);
		} else if (orderData?.status === OrderStatuses.IN_PROGRESS) {
			setActiveOrderMessage(ORDER_IN_PROGRESS_MESSAGE);
		} else {
			setActiveOrderMessage("");
		}
	}, [orderData]);

	return activeOrderMessage ? (
		<Wrapper>
			<PrimaryTextLight>{activeOrderMessage}</PrimaryTextLight>
		</Wrapper>
	) : (
		<></>
	);
};

export default ActiveOrderMessage;
